import { Svg } from 'common/assets'
import {
  AnimatedImage,
  Container,
  ContantContainer,
  DesktopWrap,
  ImageBadge,
  ImageContainer,
  LinksList,
  MobileImagesWrap,
  MobileTextDescription,
  Title,
  TitleWrapper,
} from './styled'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { LandingContext } from 'common/contexts/Landing/Landing'
import { baseURL } from 'models'
import { useNavigate } from 'react-router-dom'
import { Button } from 'components/buttons'

export const BanquetMain = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { landing } = useContext(LandingContext)
  const description = landing?.banketDescription?.find(
    el => el.lang === language,
  )?.value
  const navigate = useNavigate()
  return (
    <Container>
      <ContantContainer>
        <ImageBadge>
          <use href={Svg.sprite + '#icon-badge'} />
        </ImageBadge>
        {/* <StyledBrand src={Svg.SignOne} alt="icon brand" /> */}
        <TitleWrapper>
          <Title>{t('banquetTitle')}</Title>
        </TitleWrapper>
        <MobileImagesWrap $count={landing?.banketMainImages?.length}>
          {landing?.banketMainImages?.map((item, i) => (
            <AnimatedImage
              key={item}
              src={baseURL + '/public/' + item}
              alt={`photo` + i + 1}
            />
          ))}
        </MobileImagesWrap>
        <DesktopWrap>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[0]}
            />
            <p>{description}</p>
          </ImageContainer>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[1]}
            />
          </ImageContainer>
        </DesktopWrap>
        <LinksList>
          {landing?.banketTerms && (
            <Button.Text
              onClick={() =>
                window.open(
                  baseURL + '/public/' + landing?.banketTerms,
                  '_blank',
                )
              }>
              {t('conditions')}
            </Button.Text>
          )}
          {landing?.banketMenu && (
            <Button.Text
              onClick={() =>
                window.open(
                  baseURL + '/public/' + landing?.banketMenu,
                  '_blank',
                )
              }>
              {t('menu')}
            </Button.Text>
          )}
          {landing?.banketContactPhone && (
            <a href={`tel:${landing?.banketContactPhone?.replace(/\D/g, '')}`}>
              {landing?.banketContactPhone.toUpperCase()}
            </a>
          )}
        </LinksList>
        <MobileTextDescription>{description}</MobileTextDescription>
      </ContantContainer>
    </Container>
  )
}
